import React, { useEffect, useState } from "react";
import "./topnav.css";
import { Link } from "react-router-dom";
import Dropdown from "../dropdown/Dropdown";
import { useSelector, useDispatch } from "react-redux";
import config from "../../api/config";
import { setUser } from "../../redux/actions/AuthAction";
import AvatarPicture from "../AvatarPicture";
import { Skeleton } from "@mui/material";
import { IoKeyOutline, IoCalendarOutline, IoMenu } from "react-icons/io5";
import differenceInDays from "date-fns/differenceInDays";
const user_menu = [
  {
    icon: "bx bx-user",
    content: "Профиль",
    to: "/profile",
  },

  {
    icon: "bx bx-log-out-circle bx-rotate-180",
    content: "Выйти",
    to: "/",
    onClick() {
      localStorage.clear();
      window.location.reload();
    },
  },
];

const renderUserToggle = (user) => (
  <div className="topnav__right-user">
    {user ? (
      <AvatarPicture size="40" image={user?.photo} />
    ) : (
      <Skeleton variant="circular" width={40} height={40} />
    )}
    <div className="topnav__right-user__name">
      {user ? (
        <p className="text-white m-0">
          {`${user?.firstName} ${user?.lastName}`}
        </p>
      ) : (
        <Skeleton variant="text" />
      )}
      {user ? (
        <p className="desc mb-0">id: {user?.id}</p>
      ) : (
        <Skeleton variant="text" />
      )}
    </div>
  </div>
);
const renderSidebarToggle = (handler) => (
  <div className="topnav__right-user" onClick={handler}>
    <h4 className="text-white ">
      <IoMenu />
    </h4>
  </div>
);

const renderUserMenu = (item, index) => (
  <Link to={item.to} key={index}>
    <div className="notification-item" onClick={item.onClick}>
      <i className={item.icon}></i>
      <span>{item.content}</span>
    </div>
  </Link>
);

const RenderUserInfo = ({ user, small }) => (
  <div className="d-flex flex-wrap">
    {user !== null ? (
      user.tariffExpireDate ? (
        <div className="topnav__right-item d-flex align-items-center me-auto">
          <IoCalendarOutline fontWeight={"bold"} fontSize={25} />
          <p className="ms-2 mb-0">
            Осталось{" "}
            <span className="second-color">
              {differenceInDays(new Date(user.tariffExpireDate), new Date())}
            </span>
            дней
          </p>
        </div>
      ) : null
    ) : null}
    {user !== null ? (
      user.countKey ? (
        <div
          className={`topnav__right-item d-flex align-items-center ${
            small && "ms-0 my-3"
          }`}
        >
          <IoKeyOutline fontWeight={"bold"} fontSize={25} />
          <p className=" mb-0">
            Осталось <span className="second-color">{user.countKey}</span>{" "}
            ключевых слов
          </p>
        </div>
      ) : null
    ) : (
      <Skeleton variant="text" width={200} />
    )}
  </div>
);

const Topnav = ({ breakpoint, sidebar, open }) => {
  const reducer = useSelector((state) => state.reducer);

  const dispatch = useDispatch();
  useEffect(() => {
    config
      .get("/api/auth/v1/me")
      .then((data) => dispatch(setUser(data.data.objectKoinot)));
  }, [dispatch]);

  const [user, setUserm] = useState(null);
  useEffect(() => {
    if (reducer.user)
      setUserm({
        firstName: reducer.user?.firstName,
        lastName: reducer.user?.lastName,
        id: reducer.user?.id,
        photo: reducer.user?.photo?.link,
        countKey: reducer.user?.countKey,
        tariffExpireDate: reducer.user?.tariffExpireDate,
      });
  }, [reducer]);
  // const curr_user = {
  //   display_name: `${user?.firstName} ${user?.lastName}`,
  //   image: user?.photo,
  //   desc: `id: ${user?.id}`,
  // };

  return (
    <div className="topnav ">
      {breakpoint && (
        <div className="topnav__right-item">
          <Dropdown
            customToggle={() => renderSidebarToggle()}
            small={true}
            contentData={sidebar}
            // renderItems={(item, index) => renderNotificationItem(item, index)}
            renderFooter={<RenderUserInfo user={user} small={true} />}
          />
        </div>
      )}
      <div className="topnav__links ">
        <Link to="/about">О проекте</Link>
      </div>
      <div className="topnav__right me-3">
        <div className="topnav__right-item">
          {" "}
          {!breakpoint && <RenderUserInfo user={user} />}
        </div>
        <div className="topnav__right-item">
          {/* dropdown here */}
          <Dropdown
            customToggle={() => renderUserToggle(user)}
            contentData={user_menu}
            renderItems={(item, index) => renderUserMenu(item, index)}
          />
        </div>

        {/* <div className="topnav__right-item">
          <ThemeMenu />
        </div> */}
      </div>
    </div>
  );
};

export default Topnav;
